<div class="page-content container">
  <div class="page-header">
    <h1>{{ translationManager.getTranslation('bob_label_634e62cd3f334555a8c1a40b') }}{{customHeaderText}}</h1></div>
  <div class="page-data shadow-sm">
    <div class="page-part">
      <div class="alert alert-info"><span><i
        class="fa fa-info-circle"></i>{{ translationManager.getTranslation('Страница за приказ ставки понуде') }}</span>
      </div>
    </div>
<!--    <div class="page-part" >-->
<!--      <div class="page-actions">-->
<!--        <button *ngIf="state != viewState.Details" class="btn btn-success" (click)="selectRequestItem()"><i-->
<!--          class="fa fa-plus mr-1"></i> {{ translationManager.getTranslation('Додати нови') }}</button>-->
<!--      </div>-->
<!--    </div>-->
    <div class="app-table-panel" app-table>
      <div class="app-table-used-filters">
        <div class="app-table-used-filters-title">
          <span>{{ translationManager.getTranslation('Искоришћени филтери') }}</span></div>
        <div class="app-table-used-filter-items" search-tags>
          <div class="app-table-used-filter-items-no-content" search-tag-no-content>
            <span>{{ translationManager.getTranslation('Без искоришћених филтера') }}</span></div>
          <div class="app-table-used-filter-item" style="display: none" search-tag-prototype><span><i
            search-tag-prototype-title></i><i class="app-table-used-filter-item-value"
                                              search-tag-prototype-value></i></span><a href="javascript:;"
                                                                                       [title]="translationManager.getTranslation('Обрисати филтер')"
                                                                                       search-tag-prototype-close><i
            class="fas fa-times"></i></a></div>
          <div class="app-table-used-filter-item app-table-used-filter-item-order" style="display: none"
               order-tag-prototype><span><i order-tag-prototype-title></i><i class="app-table-used-filter-item-value"
                                                                             order-tag-prototype-value></i></span><a
            href="javascript:;" [title]="translationManager.getTranslation('Обрисати филтер')"
            order-tag-prototype-close><i class="fas fa-times"></i></a></div>
        </div>
      </div>
      <div class="app-table-filter-panel" filter>
        <div class="app-table-filter-icon"><a href="javascript:;"
                                              [title]="translationManager.getTranslation('Филтрирај ентитете')"
                                              filter-open><i class="fas fa-filter"></i></a></div>
        <div class="app-table-filter">
          <div class="app-table-filter-search">
            <div class="app-table-filter-title"><span>{{ translationManager.getTranslation('Филтери') }}</span><a
              href="javascript:;" [title]="translationManager.getTranslation('Затвори филтер')" filter-close><i
              class="fas fa-times"></i></a></div>
            <div class="page-part">
              <div class="alert alert-info"><span><i
                class="fa fa-info-circle"></i>{{ translationManager.getTranslation('Доступни филтери за процес филтрирања података') }}</span>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('SupplierOfferItem_Name')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="name"
                         [search-title-new]="translationManager.getTranslation('SupplierOfferItem_Name')"
                         search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('SupplierOfferItem_ItemVersion')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="itemVersionId"
                         [search-title-new]="translationManager.getTranslation('SupplierOfferItem_ItemVersion')"
                         search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('Количина')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="amount"
                         [search-title-new]="translationManager.getTranslation('Количина')"
                         search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('Јединица мере')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="unitOfMeasure"
                         [search-title-new]="translationManager.getTranslation('Јединица мере')"
                         search-action="contains">
                </div>
              </div>
            </div>

            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('Јединична цена')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="unitPrice"
                         [search-title-new]="translationManager.getTranslation('Јединична цена')"
                         search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('Укупна цена')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="totalPrice"
                         [search-title-new]="translationManager.getTranslation('Укупна цена')"
                         search-action="equals">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('Валута')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="currency"
                         [search-title-new]="translationManager.getTranslation('Валута')"
                         search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{translationManager.getTranslation('Додатни трошак')}}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="additionalCost"
                         [search-title-new]="translationManager.getTranslation('Додатни трошак')"
                         search-action="equals">
                </div>
              </div>
            </div>
            <div class="app-form-element-buttons">
              <button class="btn btn-success" do-search><i
                class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Филтрирај') }}</button>
              <button class="btn btn-danger" reset-search><i
                class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Поништи') }}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="app-table">
        <table class="table table-striped text-dark-m1">
          <thead>
          <tr class="bgc-primary-tp2 text-white">
            <!-- <th style="width: 30%"> -->
            <th>
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по називу')" order order-entity="name">
                {{ translationManager.getTranslation("Назив") }}
              </a>
              <!-- <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање') " order
              order-entity="DeadlineForEvaluation">
              {{translationManager.getTranslation('att_label_633ec5eab1258b876ce1383b')}}
            </a> -->
            </th>
            <!-- <th style="width: 30%"> -->
            <th style="width: 5%">
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по верзији')" order order-entity="itemVersionId">
                {{ translationManager.getTranslation("SupplierOfferItem_ItemVersion") }}
              </a>
            </th>
            <th class="right" >
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по верзији')" order order-entity="amount">
                {{ translationManager.getTranslation("Количина") }}
              </a>
            </th>
            <th>
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по верзији')" order order-entity="unitOfMeasure">
                {{ translationManager.getTranslation("Јединица мере") }}
              </a>
            </th>


            <th class="right">
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по верзији')" order order-entity="unitPrice">
                {{ translationManager.getTranslation("Јединична цена") }}
              </a>
            </th>
            <th class="right">
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по верзији')" order order-entity="totalPrice">
                {{ translationManager.getTranslation("Укупна цена") }}
              </a>
            </th>
            <th style="width: 5%">
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по верзији')" order order-entity="currency">
                {{ translationManager.getTranslation("Валута") }}
              </a>
            </th>
            <th class="right">
              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по верзији')" order order-entity="additionalCost">
                {{ translationManager.getTranslation("Додатни трошак") }}
              </a>
            </th>
            <!-- <th>
              <a href="javascript:;" #quantityHeader
                 order
                 order-entity="Amount" style="display: none">
                {{ translationManager.getTranslation('Количина') }}
              </a>
              <a href="javascript:;" #measureUnitHeader
                 order
                 order-entity="UnitOfMeasure" style="display: none">
                {{ translationManager.getTranslation('Јединица мере') }}
              </a>
            </th> -->
            <!-- <th>
              <a href="javascript:;" #currencyHeader
                 order
                 order-entity="Currency" style="display: none">
                {{ translationManager.getTranslation('Валута') }}
              </a>
              <a href="javascript:;" #singleCostHeader
                 order
                 order-entity="UnitPrice" style="display: none">
                {{ translationManager.getTranslation('Јединична цена') }}
              </a>
              <a href="javascript:;" #totalCostHeader
                 order
                 order-entity="TotalPrice" style="display: none">
                {{ translationManager.getTranslation('Укупна цена') }}
              </a>
              <a href="javascript:;" #additionalCostHeader
                 order
                 order-entity="AdditionalCost" style="display: none">
                {{ translationManager.getTranslation('Додатни трошак') }}
              </a>
            </th> -->
<!--            <th>-->
<!--              <a href="javascript:;" #articleErpIdHeader-->
<!--                 order-->
<!--                 order-entity="ArticleErpId" style="display: none">-->
<!--                {{ translationManager.getTranslation('Шифра артикла') }}-->
<!--              </a>-->
<!--              <a href="javascript:;" #articleNameHeader-->
<!--                 order-->
<!--                 order-entity="ArticleName" style="display: none">-->
<!--                {{ translationManager.getTranslation('Назив артикла') }}-->
<!--              </a>-->
<!--            </th>-->
<!--            <th style="width: 10%">-->
<!--              <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по статусу')" order-entity="TicketItemStatusId">-->
<!--                {{ translationManager.getTranslation("Статус") }}-->
<!--              </a>-->
<!--            </th>-->
            <th style="width: 160px" class="right">
              {{ translationManager.getTranslation("Акције") }}
            </th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let item of items">
            <td><b>{{ item.name }}</b></td>
            <td><b>{{ item.itemVersionId }}</b></td>

            <!-- <td class="right"><b>{{item.amount | appvalue}}</b></td> -->

            <td >
              <b>
                <p-inputNumber
                [(ngModel)]="item.amount"
                mode="decimal"
                [locale]= "localeService.locale()"
                [minFractionDigits]="2"
                InputFloatNumber=true [disabled]="true" inputStyleClass="textRight"
                ></p-inputNumber>
              </b>
            </td>

            <td><b>{{item.unitOfMeasure | appvalue}}</b></td>

            <td>
              <b>
                <p-inputNumber
                [(ngModel)]="item.unitPrice"
                mode="decimal"
                [locale]= "localeService.locale()"
                [minFractionDigits]="2"
                InputFloatNumber=true [disabled]="true" inputStyleClass="textRight"
                ></p-inputNumber>
              </b>
            </td>

            <td>
              <b>
                <p-inputNumber
                [(ngModel)]="item.totalPrice"
                mode="decimal"
                [locale]= "localeService.locale()"
                [minFractionDigits]="2"
                InputFloatNumber=true [disabled]="true" inputStyleClass="textRight"
                ></p-inputNumber>
              </b>
            </td>

            <!-- <td class="right"><b>{{item.unitPrice | appvalue}}</b></td>
            <td class="right"><b>{{item.totalPrice | appvalue}}</b></td> -->
            <td><b>{{item.currencyName | appvalue}}</b></td>

            <td>
              <b>
                <p-inputNumber
                [(ngModel)]="item.additionalCost"
                mode="decimal"
                [locale]= "localeService.locale()"
                [minFractionDigits]="2"
                InputFloatNumber=true [disabled]="true" inputStyleClass="textRight"
                ></p-inputNumber>
              </b>
            </td>

            <!-- <td class="right"><b>{{item.additionalCost | appvalue}}</b></td> -->




            <!-- <td>
              <div class="app-table-cell-vertical">
                <div class="app-table-cell-vertical-item">
                                        <span>
                                            <a href="javascript:;" (click)="quantityHeader.click()" [title]="translationManager.getTranslation('Сортирање по количини')">
                                              {{ translationManager.getTranslation('Количина') }}
                                            </a>
                                        </span>
                  <div>
                    <span>{{item.amount | appvalue}}</span>
                  </div>
                </div>
                <div class="app-table-cell-vertical-item">
                                        <span>
                                            <a href="javascript:;" (click)="measureUnitHeader.click()" [title]="translationManager.getTranslation('Сортирање по јединици мере')">
                                              {{ translationManager.getTranslation('Јединица мере') }}
                                            </a>
                                        </span>
                  <div>
                    <span>{{item.unitOfMeasure | appvalue}}</span>
                  </div>
                </div>
              </div>
            </td> -->
            <!-- <td>
              <div class="app-table-cell-vertical">
                <div class="app-table-cell-vertical-item">
                                        <span>
                                            <a href="javascript:;"  (click)="currencyHeader.click()" [title]="translationManager.getTranslation('Сортирање по валути')">
                                              {{ translationManager.getTranslation('Валута') }}
                                            </a>
                                        </span>
                  <div>
                    <span>{{item.currencyName | appvalue}}</span>
                  </div>
                </div>
                <div class="app-table-cell-vertical-item">
                                        <span>
                                            <a href="javascript:;" (click)="singleCostHeader.click()" [title]="translationManager.getTranslation('Сортирање по јединичној цени')">
                                              {{ translationManager.getTranslation('Јединична цена') }}
                                            </a>
                                        </span>
                  <div>
                    <span>{{item.unitPrice | appvalue}}</span>
                  </div>
                </div>
                <div class="app-table-cell-vertical-item">
                                        <span>
                                            <a href="javascript:;" (click)="totalCostHeader.click()" [title]="translationManager.getTranslation('Сортирање по укупној цени')">
                                              {{ translationManager.getTranslation('Укупна цена') }}
                                            </a>
                                        </span>
                  <div>
                    <span>{{item.totalPrice | appvalue}}</span>
                  </div>
                </div>
                <div class="app-table-cell-vertical-item">
                                        <span>
                                            <a href="javascript:;" (click)="additionalCostHeader.click()" [title]="translationManager.getTranslation('Сортирање по додатном трошку')">
                                              {{ translationManager.getTranslation('Додатни трошак') }}
                                            </a>
                                        </span>
                  <div>
                    <span>{{item.additionalCost | appvalue}}</span>
                  </div>
                </div>
              </div>
            </td> -->
<!--            <td>-->
<!--              <div class="app-table-cell-vertical">-->
<!--                <div class="app-table-cell-vertical-item">-->
<!--                                        <span>-->
<!--                                            <a href="javascript:;" (click)="articleErpIdHeader.click()" [title]="translationManager.getTranslation('Сортирање по шифри артикла')">-->
<!--                                              {{ translationManager.getTranslation('Шифра артикла') }}-->
<!--                                            </a>-->
<!--                                        </span>-->
<!--                  <div>-->
<!--                    <span>{{item.articleErpId | appvalue}}</span>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="app-table-cell-vertical-item">-->
<!--                                        <span>-->
<!--                                            <a href="javascript:;" (click)="articleName.click()" [title]="translationManager.getTranslation('Сортирање по називу артикла')">-->
<!--                                              {{ translationManager.getTranslation('Назив артикла') }}-->
<!--                                            </a>-->
<!--                                        </span>-->
<!--                  <div>-->
<!--                    <span>{{item.articleName | appvalue}}</span>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </td>-->
<!--            <td>{{ translationManager.getTranslation('TicketItemStatus-UniqueIdentifier#' + item.ticketItemStatusUniqueIdentifier) }}</td>-->
            <td class="right">
              <div class="table-actions">
                <a href="javascript:;" [title]="translationManager.getTranslation('Детаљи')" (click)="itemDetails(item)">
                  <i class="far fa-file"></i>
                </a>
                <a href="javascript:;" [title]="translationManager.getTranslation('Измена')" (click)="itemEdit(item)"
                   *ngIf="state != viewState.Details">
                  <i class="far fa-file-alt"></i>
                </a>
                <a  href="javascript:;" [title]="translationManager.getTranslation('Копирање')" (click)="itemCopy(item)"
                  *ngIf="item.itemVersionId < 5 && item.isMaxItemVersion && state != viewState.Details && !isDisabledByProcurementModel()">
                  <i class="far fa-copy"></i>
                </a>
                <a  href="javascript:;" class="red" [title]="translationManager.getTranslation('Брисање')" (click)="itemDelete(item.id)"
                    *ngIf="state != viewState.Details && item.itemVersionId != 1 && item.isMaxItemVersion">
                  <i class="far fa-trash-alt"></i>
                </a>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="no-content" *ngIf="!items || items.length == 0">
          <span>{{ translationManager.getTranslation('Без података') }}</span></div>
      </div>
      <div class="app-table-pagination">
        <div>
          <div pagination><span>{{ translationManager.getTranslation('Страна') }}</span><select pagination-pages>
            <option>1</option>
          </select><span>{{ translationManager.getTranslation('од') }}</span><span pagination-pages-count>-</span><span
            class="app-table-pagination-arrows"><a href="javascript:;"
                                                   [title]="translationManager.getTranslation('Иди на почетак')"
                                                   pagination-first-page><i class="fas fa-angle-double-left"></i></a><a
            href="javascript:;" [title]="translationManager.getTranslation('Претходна')" pagination-previous-page><i
            class="fas fa-angle-left"></i></a></span><span class="app-table-pagination-arrows"><a href="javascript:;"
                                                                                                  [title]="translationManager.getTranslation('Следећа')"
                                                                                                  pagination-next-page><i
            class="fas fa-angle-right"></i></a><a href="javascript:;"
                                                  [title]="translationManager.getTranslation('Иди на крај')"
                                                  pagination-last-page><i
            class="fas fa-angle-double-right"></i></a></span><span>{{ translationManager.getTranslation('Број редова за приказ') }}</span><select
            pagination-sizes>
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select></div>
        </div>
        <div class="app-table-pagination-sizes">
          <div><span>{{ translationManager.getTranslation('Укупан број слогова') }}</span><span
            pagination-total-count>-</span></div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-modal [show]="showDeleteModal" [title]="translationManager.getTranslation('Брисање')">
  <div class="app-modal-content">
    <label>{{ translationManager.getTranslation('Да ли сте сигурни да желите да обришете артикал?') }}</label></div>
  <div class="app-modal-actions">
    <button class="btn btn-success" (click)="delete()"><i
      class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Да') }}</button>
    <button (click)="showDeleteModal = false" class="btn btn-warning"><i
      class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Не') }}</button>
  </div>
</app-modal>

<!--<app-request-item-select #requestItemSelect [requestId]="requestId"></app-request-item-select>-->
<app-supplier-offer-item-detail #supplierOfferItemDetail [state]="stateDetail" [isAuctionStarted]="isAuctionStarted"></app-supplier-offer-item-detail>
